// Enums
enum ESellerExaminationStatuses {
  'pending',
  'approved',
  'declined',
}

enum EUserStatuses {
  'not_checked',
  'valid',
  'invalid'
}

enum EUserSubscription {
  'credits',
  'subscription',
  'fast-download',
}

enum ESellerPayoutStatuses {
  'waiting',
  'confirmed',
  'approved',
  'paid',
  'denied'
}

export enum EAxiosResponseStatuses {
  'success',
  'error'
}

// Interfaces
export interface IModel {
  name?: string
  file?: any,
  model: {
    model_name?: string
    model_address?: string
    model_date_signed?: string
    model_dob?: string
    model_email?: string
    model_phone?: string
    model_signature: undefined,
  },
  photographer: {
    photographer_address?: string
    photographer_email?: string
    photographer_name?: string
    photographer_phone?: string
    photographer_signature: any,
    photographer_date_signed: any
  },
  witness: {
    witness_name?: string
    witness_date_signed?: string
    witness_signature: any,
  },
}
export interface IProperty {
  name?: string,
  file?: any,
  created_date?: any,
  owner: {
    owner_name?: string,
    owner_address?: string,
    owner_date_signed?: any,
    owner_email?: string,
    owner_phone?: string,
    owner_signature?: any,
  },
  witness: {
    witness_name?: string,
    witness_date_signed?: any
    witness_signature?: any,
  },
}

export interface IMinor {
  name?: string, file?: any,
  minor: {
    minor_name: string | undefined
    minor_path: undefined | File,
    minor_dob: string | undefined
  },
  parent: {
    parent_name?: string
    parent_address?: string
    parent_phone?: string
    parent_email?: string
    parent_date_signed?: string
    parent_signature?: any,
  },
  photographer: {
    photographer_address?: string
    photographer_email?: string
    photographer_name?: string
    photographer_phone?: string
    photographer_date_signed?: any
    photographer_signature?: any,
  },
  witness: {
    witness_name?: string
    witness_date_signed?: any
    witness_signature?: any,
  }
}

export interface ISize {
  id: number,
  updatedAt: string,
  createdAt: string
  displayPrice: string,
  eps: number,
  png: number,
  jpg: number,
  licenseId: number,
  licenseName: string,
  name: string,
  price: number,
  priority: number,
  size: number,
  title_en: string,

}
export interface ILicense {
  id: number,
  isActive: number,
  name: string,
  priority: number,
  slug: string,
  sizes: ISize[],
  title_en: string,
  updatedAt: string,
  createdAt: string
}
export interface ICategory {
  id: number,
  name: string,
  updatedAt: string,
  createdAt: string
}
export interface IImage {
  author?: any,
  models?: {
    minor?: any,
    model?: any,
  },
  isFavorite?: boolean,
  canUsedForAi?: number,
  categories?: ICategory[],
  updatedAt?: string,
  createdAt?: string,
  downloads?: number,
  extension?: string,
  filesize?: string,
  freeDownloads?: number,
  height?: number,
  id?: number,
  isAdult?: number,
  isAi?: number,
  isEditorial?: number,
  isExamination?: number,
  isFeatured?: number,
  keywords?: string[],
  mediumURL?: string,
  networkAi?: string,
  prientation?: string,
  originalFilename?: string,
  parent?: any,
  reason?: any,
  releases?: any,
  sessionId?: number,
  session_id?: number,
  sizes?: ISize[],
  status?: string,
  thumbURL?: string,
  title?: string,
  type?: any,
  views?: number,
  width?: number,
  withWatermark?: number
}

export interface IDownload {

  id: number,
  comment?: string,
  category: ICategory,
  updatedAt: string,
  createdAt: string,
  downloads: number,
  image: any,
  license: ILicense,
  licenseSize: ISize
  download_link: string,
}
export interface IPixels {
  height: number,
  width: number,
}
export interface IInches {
  height: number,
  width: number,
  dpi: number
}
export interface ISizeLicense {
  id: number,
  name?: string,
  displayPrice: string,
  price: number,
  pixels?: IPixels,
  inches? :IInches
}
export interface ILicenseSize {
  type: string,
  sizes?: ISizeLicense[]

}
export interface IExtensionImage {
  licenseId?: number,
  licenseName?: string,
  licenses?: ILicenseSize[]
  id?: number
}

export interface ISizeSelected  {
  licenseId: number
  licenseName: string
  displayPrice: string
  price: number
  id: number
  type: string
  sizeName: string;
  sizePixels: {
    width: number;
    height: number;
  }
  sizeInches: {
    width: number;
    height: number;
  }
}
export type typeResponse = {
  data?: any,
  message?: string,
  status?: string
}
export interface IImageLightbox {
  size: ISizeLicense,
  category: ICategory,
  width?: number,
  id?: number,
  title?: string,
  image_id: number,
  list_id?: number,
  thumbURL?: string,

}
export interface IPaginations {
  currentPage?: number,
  perPage?: number,
  totalPages?: number
}
export interface IOrderDaily {
  before_tax?: string,
  earnings?: string,
  id?: number,
  image_id?: number,
  image_size?: string,
  plan?: string,
  returned?: any,
  tax?: string,
  thumbURL?: string,
  category?: string,
}

export interface IDailyEarning {
  downloads?: number,
  earnings?: string,
pagination?: IPaginations,
  orders?: IOrderDaily[]
}
export interface Iinvoice {
  updatedAt?: string,
  createdAt?: string,
  id?: any,
  name?: string,
  type?: string,
  series?: string,
  number?: number,
  status?: string,
  total?: string,
  taxes?: string,
  vat_percent?: string,
  vat?: string,
  payment_status?: string,
  paid_at?: any,
  product_name?: string,
  platformSubscriptionId: string | null;
  subscription?: {
    uuid: string;
  }
  plan?: {
    uuid: string;
  }
}

export interface ITaxForm {
  id: number;
  status: string;
  tax_form: string;
  year: number;
  country: string;
  displayStatus: string;
}
export interface IPaymentHistory {
  id: number;
  status: string;
  displayStatus: string | null;
  confirmed_at: string | null;
  date: string;
  payout_info: string | null;
  payout_method: string | null;
}

export interface INotifications {
  id?: number;
  isRead: number;
  message?: string;
  type?: string;
  updatedAt?: string
  createdAt?: string
  data: any;
}

export interface ITimezone {
  id: number;
  name: string;
  abbreviation: string;
}

export interface IPermissions {
  id: number;
  name: string;
}

export interface IRole {
  id: number;
  name: string;
  permissions: IPermissions[];
  slug: string;
  users_count: number;
  created_at: string;
  updated_at: string;
}

export interface IUserSubscription {
  id: number;
  name: string;
  is_active: boolean;
  type: keyof typeof EUserSubscription;
  price: number;
  downloads: number;
  downloads_used: number;
  credits: number;
  credits_used: number;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
}

export interface IUserAddress {
  id: number;
  company: string;
  firstName: string;
  lastName: string;
  name: string;
  address: string;
  city: string;
  zip: string;
  country: string;
  state: string | null;
  vatNumber: string | null;
  phone: string | null;
  createdAt: string;
  updatedAt: string;
}
export interface IUser {
  id: number;
  country: string | null;
  firstName: string;
  lastName: string;
  name: string;
  username: string;
  tax_identication_number: string;
  email: string;
  timezone: ITimezone;
  lang: string;
  inExamination: boolean;
  sellerExamination: {
    id: number;
    status: keyof typeof ESellerExaminationStatuses;
    displayStatus: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  avatar: string | null;
  design_photo: string | null;
  id_file: string | null;
  role: IRole;
  phone: string | null;
  isStripeAccountActive: boolean;
  status: keyof typeof EUserStatuses;
  displayStatus: string;
  reason: string | null;
  newsletter: string | null;
  website: string | null;
  facebook: string | null;
  linkedin: string | null;
  twitter: string | null;
  pinterest: string | null;
  instagram: string | null;
  phone_number: string | null;
  sellerEarningsTotal: number;
  sellerEarningsPaid: number;
  sellerEarningsUnpaid: number;
  creditsAvailable: number;
  hasRoyaltyFreeSubscription: boolean;
  hasExtendedSubscription: boolean;
  activeRoyaltyFreeSubscription: IUserSubscription | null;
  activeExtendedSubscription: IUserSubscription | null;
  lastBankAccount: string | null;
  lastPaypalEmail: string | null;
  lastSellerPayout: ISellerPayout | null;
  lastSellerTaxForm: ITaxForm | null;

  /**
   * Minimum payout threshold in CENTS (unsigned integer) — not
   * dollars. Divide by 100 before displaying to the user or
   * comparing against `sellerEarningsUnpaid` (which IS in dollars).
   */
  minPayout: number;

  /**
   * Saved payout destinations per method, auto-filled into the
   * payout request form when the seller picks a method. Each is
   * whatever identifier the seller entered in AccountSettings
   * (usually an email for PayPal/Skrill/Payoneer; a tag or IBAN
   * for Revolut).
   */
  payoutPaypal: string | null;
  payoutPayoneer: string | null;
  payoutSkrill: string | null;
  payoutRevolut: string | null;
  addresses: IUserAddress[];
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface ISellerPayout {
  id: number;
  amount: number;
  payout_method: string;
  seller_login: string;
  seller_country: string;
  seller: IUser;
  payout_info: string | null;
  status: keyof typeof ESellerPayoutStatuses;
  paid_at: string | null;
  denied_reason: string | null;
  denied_at: string | null;
  payment_transaction_id: string | null;
  payment_proof: string | null;
  created_at: string ;
  deleted_at: string | null;
  request_payment_id: number | null;
}
type imageUpload = {
  extension: string,
  filesize: string,
  height: number,
  imageId: number,
  medium: string
  orientation: string,
  originalFilename?: string,
  originalFileName?: string,
  sessionId: string,
  thumbnail: string,
  width: number

}
export interface ImagesKey {
  [key: string]: imageUpload[];
}
export interface IUploadStep1 {
  images?: ImagesKey,
  sessionId?: number,
  inExamination?: boolean,
  unsavedImages?: []
}

export interface Ticket {
  id: string;
  ticket_number: string;
  subject: string;
  category: string;
  status: keyof typeof ETicketStatuses;
  priority: keyof typeof ETicketPriorites;
  created_at: string;
  updated_at: string;
  messages_count: number;
  assigned_to: {
    id: number;
    name: string;
    assigned_at: string;
  } | null;
  last_message_from: 'user' | 'admin';
}

export interface TicketMessage {
  id: string;
  message: string;
  sender_type: 'user' | 'admin';
  sender_name: string;
  created_at: string;
  attachments?: Array<{
    id: string;
    support_ticket_id: string;
    support_message_id: string;

    original_name: string;
    file_name: string;
    mime_type: string;
    file_size: number;
    file_size_human: string;
    file_extension: string;

    uploaded_by: number;
    uploader_name: string;
    upload_source: string;

    created_at: string;
    download_count: number;
    last_downloaded_at: string;
    download_url: string | null;
    
    is_image: boolean;
    is_document: boolean;
    file_icon: string;
    uploaded_ago: string;
  }>;
}

export interface TicketDetails {
  id: string;
  ticket_number: string;
  subject: string;
  category: string;
  status: keyof typeof ETicketStatuses;
  priority: keyof typeof ETicketPriorites;
  assigned_to: {
    id: number;
    name: string;
    assigned_at: string;
  } | null;
  created_at: string;
  updated_at: string;
  rating: number | null;
  messages: TicketMessage[];
}

export enum ETicketPriorites {
  'low',
  'medium',
  'high'
}

export enum ETicketStatuses {
  'open', 
  'in_progress', 
  'resolved', 
  'closed'
}